import { TextField, Stack, Typography, InputAdornment } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SelectCountries from "../../../../../Select/SelectCountries";
import { Controller, useFormContext } from "react-hook-form";

const Register = ({
  showPassword,
  onBackToLogin,
}: {
  showPassword: boolean;
  setShowPassword: (v: boolean) => void;
  onBackToLogin: () => void;
}) => {
  const form = useFormContext();

  return (
    <Stack spacing={2.5} mt={1}>
      <Controller
        name="email"
        render={({ field }) => (
          <TextField
            label="Email"
            placeholder="email@email.com"
            fullWidth
            {...field}
            error={Boolean(form.formState.errors?.["email"])}
            helperText={`${form.formState.errors?.["email"]?.message ?? ""}`}
          />
        )}
        control={form.control}
      />
      <Controller
        name="fullName"
        render={({ field }) => (
          <TextField
            label="Full Name"
            placeholder="Full Name"
            fullWidth
            {...field}
            error={Boolean(form.formState.errors?.["fullName"])}
            helperText={`${form.formState.errors?.["fullName"]?.message ?? ""}`}
          />
        )}
        control={form.control}
      />
      <Controller
        name="affiliation"
        render={({ field }) => (
          <TextField
            label="Affiliation"
            placeholder="Company"
            fullWidth
            {...field}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <InfoOutlinedIcon color="action" />
                </InputAdornment>
              ),
            }}
            error={Boolean(form.formState.errors?.["affiliataion"])}
            helperText={`${form.formState.errors?.["affiliataion"]?.message ?? ""}`}
          />
        )}
        control={form.control}
      />

      {/* <SelectCountries /> */}

      <Controller
        name="password"
        render={({ field }) => (
          <TextField
            label="Password"
            type={showPassword ? "text" : "password"}
            fullWidth
            {...field}
            error={Boolean(form.formState.errors?.["password"])}
            helperText={`${form.formState.errors?.["password"]?.message ?? ""}`}
          />
        )}
        control={form.control}
      />
      <Controller
        name="confirmPassword"
        render={({ field }) => (
          <TextField
            label="Confirm Password"
            type={showPassword ? "text" : "password"}
            fullWidth
            {...field}
            error={Boolean(form.formState.errors?.["confirmPassword"])}
            helperText={`${form.formState.errors?.["confirmPassword"]?.message ?? ""}`}
          />
        )}
        control={form.control}
      />

      <Stack direction="row" gap={0.5}>
        <Typography color="#515167">Already have an account?</Typography>
        <Typography
          component="span"
          color="#1E88E5"
          sx={{
            cursor: "pointer",
            fontWeight: 400,
            lineHeight: "150%",
            letterSpacing: "0.15px",
            textDecorationLine: "underline",
            textDecorationStyle: "solid",
            textDecorationSkipink: "none",
            textDecorationThickness: "auto",
            textUnderlineOffset: "auto",
          }}
          onClick={onBackToLogin}
        >
          Click here to login
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Register;
